import BootstrapTable from "./CommanPage";
import { getCoinPricesByCoinId, createCoinPrice } from "../../../api/coinPrice";
import { useLocation, useParams } from "react-router-dom";
import { getCoinById } from "../../../api/coin";
import { useEffect, useState } from "react";

const ManageCoinsPrice = () => {
  const { coinId } = useParams();

  const [coinName, setCoinName] = useState("");

  useEffect(() => {
    const fetchCoin = async () => {
      if (!coinId) return;
      try {
        const data = await getCoinById(coinId);
        setCoinName(data.name || "");
      } catch (error) {
        console.error("Failed to fetch coin:", error);
      }
    };
    fetchCoin();
  }, [coinId]);

  const handleCreateRecord = (data) => {
    return createCoinPrice({ ...data, coinId });
  };

  const MANAGE_COIN_PRICE_FIELDS = [
    {
      name: "startPrice",
      label: "Start Price",
      type: "number",
      placeholder: "Enter Your Start Price",
      isForm: true,
      isTable: true,
      validation: {
        required: "Coin Start Price is required",
      },
    },
    {
      name: "midPrice",
      label: "Mid Price",
      type: "number",
      placeholder: "Enter Your Mid Price",
      isForm: true,
      isTable: true,
      validation: {
        required: "Coin Mid Price is required",
      },
    },
    {
      name: "endPrice",
      label: "End Price",
      type: "number",
      placeholder: "Enter Your End Price",
      isForm: true,
      isTable: true,
      validation: {
        required: "Coin End Price is required",
      },
    },
    {
      name: "hourVolume",
      label: "24 Hour Volume",
      type: "text",
      placeholder: "Enter Your 24 Hour Volume",
      isForm: true,
      isTable: true,
      validation: {
        required: "24 Hour Volume is required",
      },
    },
    {
      name: "marketCap",
      label: "Market Cap",
      type: "text",
      placeholder: "Enter Market Cap Price",
      isForm: true,
      isTable: true,
      validation: {
        required: "Enter Market Cap Price required",
      },
    },
    {
      name: "createdAt",
      label: "Created At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
    {
      name: "updatedAt",
      label: "Updated At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
  ];

  return (
    <BootstrapTable
      fields={MANAGE_COIN_PRICE_FIELDS}
      title={coinName}
      getAllRecord={(page, recordsPerPage) =>
        getCoinPricesByCoinId(coinId, page, recordsPerPage)
      }
      createRecord={handleCreateRecord}
      showActions={false}
    />
  );
};

export default ManageCoinsPrice;
